/* eslint-disable max-len */
export default {
    ru: {
      project: {
        search: "Поиск",
        reset: "Сбросить",
        sort: "Сортировка"
      },
      projectSelect: {
        project_sort_title_up: "По названию (от А до Я)",
        project_sort_title_down: "По названию (от Я до А)",
        project_sort_time_up: "Сначала новые",
        project_sort_time_down: "Сначала старые"
      }
    },
    en: {
      project: {
        search: "Search",
        reset: "Reset",
        sort: "Sorting"
      },
      projectSelect: {
        project_sort_title_up: "By name (from A to Z)",
        project_sort_title_down: "By name (from Z to A)",
        project_sort_time_up: "New ones first",
        project_sort_time_down: "Old ones first"
      }
    }
};
